const market = {
  dsbz: "To be listed currencies",
  kpsj: "Countdown to opening/opening time",
  ykp: "Already opened",
  kpdjs: "Countdown to opening",
  worning: "Not the final transaction price, for reference only",
  swapTab_1: "USDT Swap",
  swapTab_2: "Coin Swap",
  xinshou: "Novice Tutorial:",
  xinshousum: "Signup for BiKing, Have a Perfect Trading Experience",
  smcode: "Join the official QQ community",
  // 新手教程
  zcdl: "Login",
  kjmb: "Buy",
  zcyh: "Register Now",
  smrz: "ID Verification",
  c2ccz: "C2C BUY",
  ksjy: "Start Trading",
  otccz: "OTC BUY",
  szjymm: "Set password",
  gdgjgl: "More",
  xsjc: "Beginner's Guide",
  xsjcd: "Successfully! Set trade password now",
  ljzc: "Register BiKing,Starting your Crypto journey",
  ctcz: "Please complete ID verification first",
  rzcg: "Verified! Start your crypto trade now",
  tyjy: "Start trading now",
  // 登录
  welcome: "Welcome to BiKing",
  totalAsset: "Total Asset Valuation",
  openOrder: "Orders",
  dealStats: "Stats",
  assetDeposit: "Deposit",
  fbtd: "Fiat",
  yjhz: "Transfer",
  completeRealName: "Please complete KYC verification then to withdraw",
  firstTrading: "Please set trade password before your first trading",
  winVip: "Time-limited 50% discount for BiKing members",
  login: "Log In",
  forgotPassword: "Forgot password",
  signUp: "Sign Up",
  QRcode: "QR Code",
  QR: "QR",
  passwordLogin: "Password",
  codeExpired: "QR Code expired",
  clickRefresh: "Click to refresh",
  QRsuccessfully: "Successfully",
  loginInApp: "Please confirm your login in the APP",
  backtoQR: "Back to QR Code login",
  scanInApp: "Scan in APP to login",
  downloadApp: "Download the latest version of APP",
  enterPhone: "Please enter the correct phone number",
  enterEmail: "Please enter the correct email",
  emailOrPhone: "Email/Phone",
  email: "email",
  phoneNum: "phone",
  entersixCharacters: "Please enter your password with at least 6 characters",
  password: "Password",
  verification: "Verification code shall be no less than 4 characters",
  verificationCode: "Verification Code",
  phone: "Phone",
  googleAuthentication: "Google",
  boundPhone: "You have linked a phone",
  confirm: "Confirm",
  sendCode: "Send Code",
  wrongCode: "Wrong verification code",
  noData: "No data",
  phoneLogin: "Phone",
  emailLogin: "Email",
  // 底部注册
  registerCoin: "Create a BiKing account",
  openJourney: "Start Your Crypto Journey",
  enterPhoneOrEmail: "Please enter your email/phone number",
  registerNow: "Register Now",
  // 通知栏
  moreNew: "More",
  gfgg: "Announcements",
  zxxw: "Latest News",
  ckgd: "More",
  // 榜单
  down: "Top Losers",
  up: "Top Gainers",
  newCoins: "Newest",
  // 币种区
  searchCoin: "Search",
  myMarket: "Favorites",
  yxhy: "Swap",
  wghy: "Grid Futures",
  mainBoard: "Main Zone",
  InnovationZone: "Innovation Zone",
  PotentialZone: "Potential Zone",
  LimitedZone: "Limited Zone",
  pair: "Pair",
  hy: "Contracts",
  leverage: "Max Leverage",
  latestPrice: "Latest Price",
  changeHour: "Change",
  highHour: "High(24H)",
  lowHour: "Low(24H)",
  priceTrend: "Price Trend(72H)",
  volumeHour: "24H Volume",
  noSearch: "No crypto you searched",
  noAdd: "No record",
  noYet: "Haven't listed the crypto yet",
  noBi: "No record",
  risk: "Risk Reminder",
  option: "Fut.",
  cxjy: "Currencies in Innovative Zone are subject to high risks with low liquidity and high price volatility in spite of their current achievement towards technology or marketing. It is recommended to do research in advance and make transactions within your risk tolerance.",
  qljy: "Currencies in Potential Zone are still in the early stages of development, and BiKing can’t ensure their value consensus and liquidity in terms of their inception stage. Please carefully read the related information and cautiously make investments.",
  qljyDao:
    "DAO trading zone is still in the early stage of development, and BiKing cannot guarantee its value consensus and market circulation. Please carefully read the project information before making prudent decision on whether to participate in the investment.",
  storage:
    "STO trading zone is still in the early stage of development, and BiKing cannot guarantee its value consensus and market circulation. Please carefully read the project information before making prudent decision on whether to participate in the investment.",
  dlt: "Assets in Limited Zone all have low market liquidity and may be delisted. BiKing would like to remind you to make cautious investments.",
  defi: "DEFI trading zone is still in the early stage of development, and BiKing cannot guarantee its value consensus and market circulation. Please carefully read the project information before making prudent decision on whether to participate in the investment.",
  nft: "NFT trading zone is still in the early stage of development, and BiKing cannot guarantee its value consensus and market circulation. Please carefully read the project information before making prudent decision on whether to participate in the investment.",
  default:
    "trading zone is still in the early stage of development, and BiKing cannot guarantee its value consensus and market circulation. Please carefully read the project information before making prudent decision on whether to participate in the investment.",
  // 下载宣传
  bwyh: "The choice of millions of users, the future of Blockchain",
  qqcg: "More than 2 million users worldwide choose us.",
  security: "Security&Safety",
  RSA1: "Comprehensive and multi-dimensional systemic digital asset security mechanism protect all assets.",
  // RSA2: "Cold Wallet + Multi-sig strategy to strictly protect user’s assets",
  fastDeal: "Fast Deposit&Withdrawal",
  zzyf1:
    "Automatic transaction acceleration for deposits and withdrawals, able to handle 100,000 transactions per speed.",
  // zzyf2:
  // "Automatic transaction acceleration for deposits and withdrawals in C2C trading",
  tyzs: "Exceptional User Experience",
  zycp1:
    "Outstanding product design team polishes product in every details for more convenient transactions, and pursues ultimate experience for users.",
  // zycp2: "Convenient transactions&ultimate user experience",
  CSR: "7*24 CSR",
  fwcxy1:
    "24/7 Customer Service Representative and online chat to guarantee the timely help and service.",
  // fwcxy2: "Guarantee every user's visit with the best quality of service.",
  ssgz: "Market, Trade, Wallet Now at your fingertips",
  newApp: "New Version of APP",
  zsjy: "Accessible",
  lcty: "Convenience",
  realTime: "Real time",
  kscb: "Steamless",
  downloadby: "Scan to download BiKing APP",
  // 顶部公告栏
  know: "Got it",
  r: "Days",
  s: "Hours",
  f: "Min",
  m: "Sec",
  qqg: "BUY IT NOW",
  jlblkq: "Distance Start",
  jlbljs: "Distance End",
  yrz: "Preheat",
  qgz: "subscribing",
  loginSuccess: "Login successfully, welcome to BiKing.",
  fast: "Flash",
  buy: "Purchase",
  meBuy: "Purchase now",
  fastTip: "Please enter the amount",
  price: "Reference price",
  max: "Maximum amount",
  yanzheng: "verification",
  searchPlaceholder: "Search your country or country code",
  wan: "M",
  qian: "K",
  yi: "B",
  addSelfCode: "Add Favorites",
  hz: "Swap",
  yx: "R&S",
  yjyzx: "Research's Selected",
  zx: "Favorites",
  bb: "Spot",
  hy: "Futures",
  zfb: "Gainers",
  xbb: "New",
  bd: "Pair",
  zxj: "Latest Price",
  zdf24: "24H Change",
  high24: "24H highest",
  low24: "24H Lowest",
  turnover24: "24H Trading Vol",
  zd24: "24h Change",
  zjrzd: "Price/Day Change",
  scgl: "Market Overview",
  jysj: "Transaction data",
  fyje: "Rebate amount",
  推荐链接:'Link',
  一键分享:'Sharing',
  不允许任何用户通过多:"No user is allowed to invite themselves through multiple accounts. Once verified, all rebates will be cancelled, and the handling fee rebate of the invited account will also be cancelled",
  交易人数: "Number of traders",
  使用你的推荐链接:"Only users who register using your referral link or referral code are considered your invitees. If the user does not fill in the referral code when registering, the invitation relationship is not established;",
  保留对活动的最终解释权:" If you have any questions, please contact the manual customer service. ",
  合约交易返佣: "Get high contract transaction rebates",
  合约手续费: "Contract handling fee",
  合约返佣: "Contract cumulative rebate",
  好友返佣比例: "Friends rebate ratio",
  我的返佣比例: "My rebate ratio",
  推荐人数: "Number of referees",
  推荐好友: "Recommend friends",
  推荐: "Recommend",
  推荐总览: "Recommendation overview",
  推荐码: "Recommendation code",
  推荐记录: "Recommendation record",
  是否交易: "Do you trade",
  注册时间: "Registration time (UTC+8)",
  用户邀请朋友无上限: "There is no upper limit for users to invite friends,Only the handling fee of contract transactions by the invitee will be included in the rebate;",
  由于市场环境的改变:"Due to changes in the market environment and the existence of fraud risks, Biking reserves the final right of interpretation to adjust the rebate rules at any time. ",
  被邀请人产生的真实交易手续费:"The inviter can get a commission corresponding to the transaction fee generated by the invitee, which will be returned to the inviter's account the next day. The specific time of crediting will be after 4:00 every day.;",
  被邀请人只有进行合约:"Only the handling fee of contract transactions by the invitee will be included in the rebate;",
  请输入账户UID: "Please enter account UID",
  账户UID: "Account UID",
  返佣活动规则说明: "Recommendation activity rules description:",
  返佣记录: "Recommendation record",
  ms: "Yes",
  mf: "No",
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/en.js